import { render, staticRenderFns } from "./guanqiaWinData.vue?vue&type=template&id=55022ec8&"
import script from "./guanqiaWinData.vue?vue&type=script&lang=js&"
export * from "./guanqiaWinData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55022ec8')) {
      api.createRecord('55022ec8', component.options)
    } else {
      api.reload('55022ec8', component.options)
    }
    module.hot.accept("./guanqiaWinData.vue?vue&type=template&id=55022ec8&", function () {
      api.rerender('55022ec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/guanqia/guanqiaWinData.vue"
export default component.exports